import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Select2Module } from 'ng2-select2';

import { RefundRoutingModule } from "./refund-routing.module";
import { ConsultRefundComponent } from './consult/consultrefund.component';
import { RefundComponent } from './refund.component';
import { HomeRefundComponent } from './home-refund/home-refund.component';
import { RequestRefundComponent } from './request-refund/request-refund.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        RefundRoutingModule,
        FormsModule,
        SharedModule,
        Select2Module
    ],
    declarations: [ConsultRefundComponent, RefundComponent, HomeRefundComponent, RequestRefundComponent]
})
export class RefundModule { }


// WEBPACK FOOTER //
// /app/src/app/office/refunds/refund.module.ts